import { AccountOrBankDetails } from "../../components/AccountOrBankDetails";
import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

export const AccountOrBankDetailsPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Account / Bank Detials"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Account / Bank Detials", navigateTo: "#" }
      ]}
      mainContents={<AccountOrBankDetails />}
    />
  );
};
